export default __webpack_public_path__ + "static/media/brand.38ba8ca3.png";